import { Fragment, FunctionComponent } from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { CompanySettings } from './components';
import { Settings } from './Settings';

const SettingsRouter: FunctionComponent = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path={RouteConstants.company} component={CompanySettings} />
      <PrivateRoute path={RouteConstants.settings} component={Settings} />
    </Switch>
  </Fragment>
);

export default SettingsRouter;
